// extracted by css-extract-rspack-plugin
export default {"bankSidebarWrapperRoot":"yRqq2l"};